import React, { createContext, useContext, useState } from "react";

interface OrderCrudContextType<T> {
	openOrderDialog: boolean;
	setOpenOrderDialog: (value: boolean) => void;
	selectedOrderRow: T | null;
	setSelectedOrderRow: (value: T | null) => void;
}

const OrderCrudContext = createContext<OrderCrudContextType<any>>({
	openOrderDialog: false,
	setOpenOrderDialog: () => { },
	selectedOrderRow: null,
	setSelectedOrderRow: () => { },
});

export const OrderCrudProvider = <T,>({ children }: { children: React.ReactNode }) => {
	const [openOrderDialog, setOpenOrderDialog] = useState(false);
	const [selectedOrderRow, setSelectedOrderRow] = useState<T | null>(null);

	return (
		<OrderCrudContext.Provider
			value={ { openOrderDialog, setOpenOrderDialog, selectedOrderRow, setSelectedOrderRow } }
		>
			{ children }
		</OrderCrudContext.Provider>
	);
};

export function useOrderCrudContext<T>() {
	return useContext(OrderCrudContext) as OrderCrudContextType<T>;
}
